import moment from 'moment';
import { EnumEnableValue } from 'src/components/EnableSwitch';
import { EnumTopicValidType } from 'src/dict/dictEnum';
import { ensureAppRoot } from 'src/utils/pathUtils';
import { TopicConfigType } from './types';

export function getIconContent(
  topicName: string | undefined | null,
  length: number = 4,
) {
  if (!topicName) return '';
  return topicName.slice(0, length);
}

/** 获取主题分享链接 */
export const getShareTopicUrl = (shortCode: string | undefined | null) => {
  if (!shortCode) return '';
  return `${window.location.origin}${ensureAppRoot(
    `/topic-share/topic?shortCode=${shortCode}`,
  )}`;
};

/** 获取主题公开分享链接 */
export const getSharePublicUrl = (shortCode: string | undefined | null) => {
  if (!shortCode) return '';
  return `${window.location.origin}${ensureAppRoot(
    `/topic-share/public?shortCode=${shortCode}`,
  )}`;
};

/** 主题公开分享状态 */
export enum PublicShareStatus {
  /** 未设置 */
  Unset = 0,
  /** 已停用 */
  Disabled = 1,
  /** 生效中 */
  Enabled = 2,
  /** 已过期 */
  Expired = 3,
  /** 未生效 */
  NotEffective = 4,
}

/** 获取主题公开分享状态 */
export const getPublicShareStatus = (
  record?: TopicConfigType.FormData | TopicConfigType.DataItem | null,
) => {
  if (!record) return undefined;
  const { enabled, valid_type, valid_start, valid_end, short_code } = record;
  if (!short_code) return undefined;
  if (!valid_type) return PublicShareStatus.Unset;
  if (enabled === EnumEnableValue.Disable) {
    // 已停用
    return PublicShareStatus.Disabled;
  }
  if (valid_type === EnumTopicValidType.permanent) {
    // 生效中
    return PublicShareStatus.Enabled;
  }

  const start = moment(valid_start);
  const end = moment(valid_end);
  const now = moment();
  if (end.isBefore(now.subtract(1, 'day'))) {
    // 已过期
    return PublicShareStatus.Expired;
  }
  if (start.isAfter(moment())) {
    // 未生效
    return PublicShareStatus.NotEffective;
  } else {
    return PublicShareStatus.Enabled;
  }
};

/** 获取主题公开分享状态文本 */
export const getPublicShareStatusText = (
  value?: ReturnType<typeof getPublicShareStatus> | TopicConfigType.DataItem,
) => {
  if (typeof value === 'object' && value !== null) {
    value = getPublicShareStatus(value);
  }
  if (value === PublicShareStatus.Unset) return '未设置';
  if (!value) return '';
  switch (value) {
    case PublicShareStatus.Disabled:
      return '已停用';
    case PublicShareStatus.Enabled:
      return '生效中';
    case PublicShareStatus.Expired:
      return '已过期';
    case PublicShareStatus.NotEffective:
      return '未生效';
    default:
      return '';
  }
};
